module.exports = __webpack_public_path__ + "7d568642b78b6895ef265e62078fd38f.png";